import shoppingIcon from "assets/images/shoppingBasket.svg";
import { EmptySection } from "../../shared/EmptySection";

export const EmptyExpensesSection = () => {
  // action

  return <EmptySection img={shoppingIcon} title="Kontroluj wydatki" />;
};
